export { List } from "@mantine/core";
export type { ListProps } from "@mantine/core";
export { listOverrides } from "./List.config";
